import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Trait {
  name: string;
  level: number;
  icon: string;
}

interface PetPersonalityProps {
  description: string;
  traits: Trait[];
  goodWith: string[];
  specialNeeds: string[];
}

const PetPersonality = ({
  description,
  traits,
  goodWith,
  specialNeeds,
}: PetPersonalityProps) => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-headline font-semibold text-foreground mb-4">
          Personality & Temperament
        </h2>
        <p className="text-base text-foreground font-body leading-relaxed">{description}</p>
      </div>

      <div>
        <h3 className="text-xl font-headline font-semibold text-foreground mb-4">
          Personality Traits
        </h3>
        <div className="space-y-4">
          {traits.map((trait, index) => (
            <div key={index}>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <Icon name={trait.icon as any} size={20} variant="outline" className="text-primary" />
                  <span className="font-body font-medium text-foreground">{trait.name}</span>
                </div>
                <span className="text-sm text-muted-foreground font-body">{trait.level}/5</span>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div
                  className="bg-primary rounded-full h-2 transition-all duration-500"
                  style={{ width: `${(trait.level / 5) * 100}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <h3 className="text-xl font-headline font-semibold text-foreground mb-4">Good With</h3>
          <div className="space-y-2">
            {goodWith.map((item, index) => (
              <div key={index} className="flex items-center gap-3 p-3 bg-success/10 rounded-lg">
                <Icon name="CheckCircleIcon" size={20} variant="solid" className="text-success" />
                <span className="font-body text-foreground">{item}</span>
              </div>
            ))}
          </div>
        </div>

        {specialNeeds.length > 0 && (
          <div>
            <h3 className="text-xl font-headline font-semibold text-foreground mb-4">
              Special Needs
            </h3>
            <div className="space-y-2">
              {specialNeeds.map((need, index) => (
                <div key={index} className="flex items-center gap-3 p-3 bg-warning/10 rounded-lg">
                  <Icon name="ExclamationCircleIcon" size={20} variant="solid" className="text-warning" />
                  <span className="font-body text-foreground">{need}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PetPersonality;